
const FEEDBACK_API = 'https://vbench.ailiantang.top/api/feedback';

const POSITIVE_ASPECTS = ['游戏玩法', '打字手感', '界面设计', '难度递进', '关卡设计', '综合都不错'];
const NEGATIVE_ASPECTS = ['玩法无趣', '打字不顺畅', '界面不美观', '难度不合理', '关卡设计差', '综合都不满意'];

export function initFeedback(): void {
  let fbRating = 0;

  const overlay = document.getElementById('feedback-overlay')!;
  const formWrap = document.getElementById('feedback-form-wrap')!;
  const successWrap = document.getElementById('feedback-success')!;
  const ratingGroup = document.getElementById('fb-rating')!;
  const aspectLabel = document.getElementById('fb-aspect-label')!;
  const aspectSelect = document.getElementById('fb-aspect') as HTMLSelectElement;
  const nameInput = document.getElementById('fb-name') as HTMLInputElement;
  const contentTextarea = document.getElementById('fb-content') as HTMLTextAreaElement;
  const errorEl = document.getElementById('fb-error')!;
  const submitBtn = document.getElementById('fb-submit') as HTMLButtonElement;

  function open(): void {
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function close(): void {
    overlay.style.display = 'none';
    document.body.style.overflow = '';
    setTimeout(reset, 300);
  }

  function reset(): void {
    formWrap.style.display = 'block';
    successWrap.style.display = 'none';
    nameInput.value = '';
    aspectSelect.value = '';
    contentTextarea.value = '';
    fbRating = 0;
    errorEl.style.display = 'none';
    ratingGroup.querySelectorAll('.fb-rating-btn').forEach(b => b.classList.remove('fb-selected'));
    aspectLabel.textContent = '🏷️ 最满意的方面';
    rebuildAspectOptions(POSITIVE_ASPECTS);
  }

  function rebuildAspectOptions(options: string[]): void {
    aspectSelect.innerHTML = '<option value="">请选择...</option>' +
      options.map(o => `<option value="${o}">${o}</option>`).join('');
  }

  // Open button
  document.getElementById('btn-feedback')?.addEventListener('click', open);

  // Close buttons
  document.getElementById('fb-close-btn')?.addEventListener('click', close);
  document.getElementById('fb-cancel')?.addEventListener('click', close);
  document.getElementById('fb-close-success')?.addEventListener('click', close);

  // Click overlay to close
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) close();
  });

  // Prevent touch propagation (mobile)
  overlay.addEventListener('touchstart', (e) => {
    e.stopPropagation();
  }, { passive: true });

  // Escape to close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.style.display === 'flex') close();
  });

  // Rating selection
  ratingGroup.addEventListener('click', (e) => {
    const btn = (e.target as HTMLElement).closest('.fb-rating-btn') as HTMLElement | null;
    if (!btn) return;
    ratingGroup.querySelectorAll('.fb-rating-btn').forEach(b => b.classList.remove('fb-selected'));
    btn.classList.add('fb-selected');
    fbRating = parseInt(btn.dataset.val || '0', 10);

    const isNegative = fbRating <= 2;
    aspectLabel.textContent = isNegative ? '🏷️ 最不满意的方面' : '🏷️ 最满意的方面';
    rebuildAspectOptions(isNegative ? NEGATIVE_ASPECTS : POSITIVE_ASPECTS);
  });

  // Continue feedback
  document.getElementById('fb-again')?.addEventListener('click', () => {
    reset();
  });

  // Submit
  submitBtn.addEventListener('click', async () => {
    const name = nameInput.value.trim() || '匿名';
    const aspect = aspectSelect.value;
    const content = contentTextarea.value.trim();

    errorEl.style.display = 'none';
    if (!fbRating) { showError('请先选择整体体验评分'); return; }
    if (!content) { showError('请填写详细反馈内容'); return; }
    if (content.length < 2) { showError('反馈内容至少需要 2 个字'); return; }

    submitBtn.disabled = true;
    submitBtn.textContent = '⏳ 提交中...';

    for (let attempt = 1; attempt <= 3; attempt++) {
      try {
        submitBtn.textContent = attempt > 1 ? `⏳ 第${attempt}次重试...` : '⏳ 提交中...';
        const ctrl = new AbortController();
        const timer = setTimeout(() => ctrl.abort(), 10000);
        const resp = await fetch(FEEDBACK_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name, rating: fbRating, aspect, content, source: 'typing-game打字练习挑战' }),
          signal: ctrl.signal
        });
        clearTimeout(timer);
        const data = await resp.json();
        if (data.success) {
          formWrap.style.display = 'none';
          successWrap.style.display = 'block';
          submitBtn.disabled = false;
          submitBtn.textContent = '🚀 提交反馈';
          return;
        }
        throw new Error(data.error || '提交失败');
      } catch (e: any) {
        if (e.message && e.message.indexOf('fetch') === -1 && e.message !== 'The user aborted a request.') break;
        if (attempt < 3) await new Promise(r => setTimeout(r, attempt * 1500));
      }
    }

    showError('提交失败，请稍后重试');
    submitBtn.disabled = false;
    submitBtn.textContent = '🚀 提交反馈';
  });

  function showError(msg: string): void {
    errorEl.textContent = msg;
    errorEl.style.display = 'block';
  }
}
